"use client";

import { productsSchema } from "../../../lib/types/schema/subscription/productSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { useSession } from "../../../session/hooks/useSession";
import { keyPublicPlans } from "./keyProducts";

export const useRequestPublicProducts = (props: UseRequestQueryProps = {}) => {
  const { status } = useSession();

  return {
    query: useRequestQuery<typeof productsSchema>({
      enabled: status !== "authenticated",
      enabledWithoutSessionToken: true,
      queryFnRequestProps: {
        schema: productsSchema,
        urlBackendPath: "/public/products",
        requestType: "other",
      },
      queryKey: keyPublicPlans(),
      ...props,
    }),
  };
};
